import {
  SET_ESCALA_FUNCIONARIO
} from './types'

export const mutations = {
  [SET_ESCALA_FUNCIONARIO] (state, payload) {
    if (Array.isArray(payload)) {
      state.funcionarios = payload
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/escalas/mutations.js